import {getReportName} from './index';

export function trackUpsellEvent(eventName, featureGateType) {
  mixpanel.track(eventName, {
    Tab: getReportName(),
    'Feature Limit': {
      ab_testing: `A/B Testing`,
      bookmark: `Saved Reports`,
      campaign: `Campaign`,
      cohorts: `Cohorts`,
      csv: `CSV Export`,
      custom_events: `Custom Events`,
      date_picker: `Data History`,
      data_management: `Data Management`,
      data_pipelines: `Data Pipelines`,
      'experiment-reporting': `Experiment Reporting`,
      flows: `Flows`,
      formulas: `Formulas`,
      funnels: `Funnels`,
      impact: `Impact`,
      jql_console: `JQL Console`,
      lookup_tables: `Lookup Tables`,
      messages: `Messages`,
      oda: `On Demand Analysis`,
      platform: `Custom Apps`,
      retention: `Retention`,
      revenue: `Revenue`,
      sampling: `Sampling`,
      sharing: `Sharing`,
      security: `Two-Factor/SSO`,
      segmentation: `Segmentation`,
      signal: `Signal`,
      team: `Team Members`,
      visual_journeys: `Visual Journeys`,
    }[featureGateType],
    'Limit Type': {
      ab_testing: `Feature Access`,
      bookmark: `Feature Limit`,
      campaign: `Feature Access`,
      cohorts: `Feature Access`,
      csv: `Feature Access`,
      custom_events: `Feature Limit`,
      date_picker: `Feature Limit`,
      data_management: `Feature Access`,
      data_pipelines: `Feature Access`,
      'experiment-reporting': `Feature Access`,
      flows: `Feature Access`,
      formulas: `Feature Access`,
      funnels: `Feature Limit`,
      impact: `Feature Access`,
      jql_console: `Feature Access`,
      lookup_tables: `Feature Access`,
      messages: `Feature Access`,
      oda: `Feature Access`,
      platform: `Feature Access`,
      retention: `Feature Limit`,
      revenue: `Feature Access`,
      sampling: `Feature Access`,
      security: `Feature Access`,
      segmentation: `Feature Limit`,
      signal: `Feature Access`,
      team: `Feature Limit`,
      visual_journeys: `Feature Access`,
    }[featureGateType],
  });
}
